import { SelectOption } from '@/components/Form/src/types'
import { traineeprofileEnum } from '@/enumerations/traineeprofileEnum'

const Type: SelectOption[] = [
  {
    label: 'Basic Training',
    value: traineeprofileEnum.Type.BasicTrainee
  },
  {
    label: 'Higher Training',
    value: traineeprofileEnum.Type.HigherTrainee
  }
]

const Status: SelectOption[] = [
  {
    label: 'Active',
    value: traineeprofileEnum.Status.Active
  },
  {
    label: 'Completed',
    value: traineeprofileEnum.Status.Completed
  },
  {
    label: 'Deferred',
    value: traineeprofileEnum.Status.Deferred
  },
  {
    label: 'Terminated',
    value: traineeprofileEnum.Status.Terminated
  }
]

const Mode: SelectOption[] = [
  {
    label: 'Full Time',
    value: traineeprofileEnum.Mode.FullTime
  },
  {
    label: 'Part Time',
    value: traineeprofileEnum.Mode.PartTime
  }
]

const summmaryActivityTypes: SelectOption[] = [
  {
    label: 'BT SEP',
    value: traineeprofileEnum.RecordActivityType.BTSEP
  },
  {
    label: 'HT SEP',
    value: traineeprofileEnum.RecordActivityType.HTSEP
  },
  {
    label: 'Activity',
    value: traineeprofileEnum.RecordActivityType.Activity
  },
  {
    label: 'Examination',
    value: traineeprofileEnum.RecordActivityType.Examination
  }
]

export const traineeprofileOption = { Type, Status, Mode, summmaryActivityTypes }
